import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Admin from "@/pages/Admin";
import ThankYou from "@/pages/ThankYou";
import Verde2050 from "@/pages/Verde2050";
import Contact from "@/pages/Contact";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import WhatWeDo from "@/pages/WhatWeDo";
import News from "@/pages/News";
import FontPreview from "@/pages/FontPreview";
import SellLand from "@/pages/SellLand";
import LandIntelligence from "@/pages/LandIntelligence";
import InvestorCircle from "@/pages/InvestorCircle";
import CircleUnsubscribe from "@/pages/CircleUnsubscribe";
import CookieBanner from "@/components/CookieBanner";
import { Privacy, Cookies, Terms, ImportantInformation } from "@/pages/Legal";
import ProjectAdmin from "@/pages/ProjectAdmin";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Verde2050 />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/projects/:slug" element={<ProjectDetail />} />
                    <Route path="/what-we-do" element={<WhatWeDo />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/land-intelligence" element={<LandIntelligence />} />
                    <Route path="/investor-circle" element={<InvestorCircle />} />
                    <Route path="/investor-circle/unsubscribe" element={<CircleUnsubscribe />} />
                    <Route path="/sell-your-land" element={<SellLand lang="en" />} />
                    <Route path="/pt/vender-terreno" element={<SellLand lang="pt" />} />
                    <Route path="/contact" element={<Contact />} />

                    <Route path="/legal/privacy" element={<Privacy />} />
                    <Route path="/legal/cookies" element={<Cookies />} />
                    <Route path="/legal/terms" element={<Terms />} />
                    <Route path="/legal/important-information" element={<ImportantInformation />} />

                    <Route path="/admin" element={<Admin />} />
                    <Route path="/font-preview" element={<FontPreview />} />
                    <Route path="/project-admin" element={<ProjectAdmin />} />
                    <Route path="/thank-you" element={<ThankYou />} />

                    {/* Redirects for old paths */}
                    {[
                        ["/verde-land-i", "/projects"], ["/portfolio", "/projects"], ["/investing", "/projects"], ["/for-investors", "/projects"],
                        ["/capital", "/what-we-do#financing"], ["/project", "/contact?type=project"],
                        ["/strategy", "/what-we-do"], ["/pillars", "/what-we-do"], ["/thesis", "/what-we-do"], ["/services", "/what-we-do"],
                        ["/platform", "/what-we-do"], ["/platforms", "/what-we-do"], ["/technology", "/land-intelligence"], ["/ventures", "/what-we-do"],
                        ["/about", "/"], ["/ai", "/land-intelligence"], ["/sell-land", "/sell-your-land"], ["/vender-terreno", "/pt/vender-terreno"], ["/pt", "/pt/vender-terreno"], ["/specialists", "/"], ["/network", "/"], ["/group", "/"], ["/lifestyle-migration", "/"],
                        ["/insights", "/news"], ["/insights/*", "/news"], ["/taylor-brokers", "/what-we-do#transactions"],
                    ].map(([from, to]) => <Route key={from} path={from} element={<Navigate to={to} replace />} />)}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <CookieBanner />
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#18382E",
                        color: "#E9E6DC",
                        border: "none",
                        borderRadius: 14,
                        fontFamily: "Inter Tight, sans-serif",
                    },
                }}
            />
            </div>
        </HelmetProvider>
    );
}

export default App;
